import Predictions from "../../../pages/shared/predictor/predictions.component"

const PredictionsRoute = () => {
  return (
    <Predictions/>
  )
}

export default PredictionsRoute